import CustomModal from '../../../../components/CustomModal'
import { useDispatch, useSelector } from 'react-redux'
import {
  setPageTabData,
} from '../../../../redux/slices/dynamicUiSlice'
import PageStickyTabs from './PageStickyTabs'
import PageStickyTabsContent from './PageStickyTabsContent'
import PageTabSubmitButton from './PageTabSubmitButton'
import PageTabActionMenu from './PageTabActionMenu'

const PageTabModal = () => {
  
  const selected = useSelector((state) => state.dynamicUi.pages.tabs.selected);
  const editTab = useSelector((state) => state.dynamicUi.pages.tabs.edit);
  const selectedTab = editTab[selected];
  const dispatch = useDispatch()


  const isActive = useSelector((state) => state.dynamicUi.pages.tabs.active)

  const isLoading = useSelector((state) => state.dynamicElements.editing.loading)


  return (
    <CustomModal
      title="Infinite Scroll Content"
      bodyClasses="max-w-screen-md"
      showModal={isActive}
      // showModal={adding || editing}
      setShowModal={() => dispatch(setPageTabData({}))}
      loading={isLoading}
      button={<PageTabSubmitButton />}
    >
      <div className="flex justify-between">
        <h2 className="text-lg font-medium mb-4">{selectedTab?.id ? "Update" : "Add"} tabs and infinite scroll content</h2>
        <PageTabActionMenu />
      </div>
      
      
      <PageStickyTabs />

      <PageStickyTabsContent />

    </CustomModal>

  )
}

export default PageTabModal
